import React from 'react';
// --- Icons ---
export const SvgIcon: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = ({ children, className, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
    >
        {children}
    </svg>
);

export const ListChecks: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="m16 21 2-2 4 4" />
        <path d="M3 7h16" />
        <path d="M3 11h16" />
        <path d="M3 15h16" />
        <path d="M3 19h10" />
    </SvgIcon>
);

export const X: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
    </SvgIcon>
);

export const Search: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
    </SvgIcon>
);

export const Loader2: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </SvgIcon>
);

export const FileText: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v6h6" />
        <path d="M10 12H8" />
        <path d="M16 12h-2" />
        <path d="M16 16H8" />
    </SvgIcon>
);

export const Calendar: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
    </SvgIcon>
);

export const User: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </SvgIcon>
);

export const Building: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <rect width="16" height="20" x="4" y="2" rx="2" ry="2" />
        <path d="M9 22v-4h6v4" />
        <path d="M8 6h.01" />
        <path d="M16 6h.01" />
        <path d="M12 6h.01" />
        <path d="M12 10h.01" />
        <path d="M12 14h.01" />
        <path d="M16 10h.01" />
        <path d="M16 14h.01" />
        <path d="M8 10h.01" />
        <path d="M8 14h.01" />
    </SvgIcon>
);

export const AlertTriangle: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </SvgIcon>
);

export const CheckCircle: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
    </SvgIcon>
);

export const Circle: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <circle cx="12" cy="12" r="10" />
    </SvgIcon>
);

export const List: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <line x1="8" y1="6" x2="21" y2="6" />
        <line x1="8" y1="12" x2="21" y2="12" />
        <line x1="8" y1="18" x2="21" y2="18" />
        <line x1="3" y1="6" x2="3.01" y2="6" />
        <line x1="3" y1="12" x2="3.01" y2="12" />
        <line x1="3" y1="18" x2="3.01" y2="18" />
    </SvgIcon>
);

export const Save: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
        <polyline points="17 21 17 13 7 13 7 21" />
        <polyline points="7 3 7 8 15 8" />
    </SvgIcon>
);

export const Trash2: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <line x1="10" y1="11" x2="10" y2="17" />
        <line x1="14" y1="11" x2="14" y2="17" />
    </SvgIcon>
);

export const Edit2: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </SvgIcon>
);

export const Plus: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
    </SvgIcon>
);

export const Printer: React.FC<React.SVGProps<SVGSVGElement> & { className?: string }> = (props) => (
    <SvgIcon {...props}>
        <polyline points="6 9 6 2 18 2 18 9" />
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
        <rect x="6" y="14" width="12" height="8" />
    </SvgIcon>
);


// WEBPACK FOOTER //
// ./src/components/common/icons.tsx